import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Store from "./Reducers/Store";

import config from "./app.json";
import React from 'react';
import ReactDOM from 'react-dom/client';
import "./Assets/Css/index.scss";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initFacebookSdk } from './Components/FacebookSDK/initFacebook';

const root = ReactDOM.createRoot(document.getElementById('root'));
initFacebookSdk(config.FacebookAppId);
window._wait = {};
window._channelsIds = [];

root.render(
  <Store>
      <App />
  </Store>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
